import { memo } from "react";
import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import CheckMarkIcon from "assets/images/icons/checkmark.svg";
import { HeroText } from "components/shared/Typography";
import ContactCustomerService from "components/auth/ContactCustomerService";
import useDialog from "hooks/useDialog";

const useStyles = makeStyles((theme: Theme) => ({
  divider: {
    background: theme.palette.grey[500],
  },
  buttons: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      flexDirection: "column",
      "& > a:first-of-type": { marginBottom: theme.spacing(2) },
    },
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      "& > a:first-of-type": { marginRight: theme.spacing(2) },
    },
  },
}));

const PasswordRecoveryForm = () => {
  const classes = useStyles();
  const { openPasswordRecoveryDialog } = useDialog();

  return (
    <Grid container justifyContent="center">
      <Grid
        item
        container
        direction="column"
        alignItems="center"
        {...(openPasswordRecoveryDialog ? { xs: 12 } : { xs: 12, md: 6 })}
      >
        <Box mb={3}>
          <HeroText align="center">Password Recovery</HeroText>
        </Box>
        <img width={80} height={80} src={CheckMarkIcon} alt="Check mark" />
        <Box py={3}>
          <Typography variant="body1" align="center">
            Password instructions have been sent to the email address you
            provided.
          </Typography>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          m={0}
          className={classes.buttons}
        >
          <Button variant="contained" href="/" color="primary" size="large">
            Return home
          </Button>
          <Button
            href="/catalog"
            variant="outlined"
            color="primary"
            size="large"
          >
            Browse catalog
          </Button>
        </Box>
        <Box my={3} width={1}>
          <Divider className={classes.divider} />
        </Box>
        <ContactCustomerService />
      </Grid>
    </Grid>
  );
};

export default memo(PasswordRecoveryForm);
